import React, { useState } from "react";

import toast from "react-hot-toast";
import PropTypes from "prop-types";
import dislike from "../../assets/images/dislike.png";
import like from "../../assets/images/like.png";
import { ingestData } from "../../bridges/BridgeServices";
import "./feedbackSurvey.scss";
import { EVENTS } from "../../utils/constants";

const FeedbackSurvey = ({ categoryAndTag, faqTitle }) => {
  const [showFeedBack, setShowFeedBack] = useState(true);

  const ingestDataHandler = answer => {
    ingestData({
      name: EVENTS.FEEDBACK_SURVEY_ANSWERED,
      data: {
        categoryAndTag: categoryAndTag?.categoryAndTag,
        concernAnswered: answer,
        faqTitle,
      },
    });
  };

  const handleClick = selection => {
    ingestDataHandler(selection);
    setShowFeedBack(false);
    toast.success("Thank you for the feedback!");
  };

  if (!showFeedBack) {
    return null;
  }

  return (
    <div className="feedback-survey">
      <div className="text">
        Did this answer your concern ?
      </div>
      <div
        className="pos-button"
        onClick={() => {
          handleClick("yes");
        }}
      >
        <div className="pos-icon">
          <img src={like} />
        </div>
        <div className="pos-text">Yes</div>
      </div>
      <div
        className="neg-button"
        onClick={() => {
          handleClick("no");
        }}
      >
        <div className="neg-icon">
          <img src={dislike} />
        </div>
        <div className="neg-text">No</div>
      </div>
    </div>
  );
};

export default FeedbackSurvey;

FeedbackSurvey.propTypes = {
  categoryAndTag: PropTypes.object,
  faqTitle: PropTypes.string,
};
